import AdminHeader from "@/components/common/AdminHeader";
import HolidaysView from "@/components/holidays";

export default function Holidays() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <HolidaysView />
      </main>
    </div>
  );
}
